import React, { useEffect, useState } from "react";
import StatsCard from "../components/StatsCard";
import { getGuideStats } from "../data/guidesService";

/** Top stats row for Guides Management page. */
type GuideStatsShape = {
  total: number;
  approved: number;
  connections: number;
  revenue: number;
};

export default function GuideStats() {
  const [stats, setStats] = useState<GuideStatsShape | null>(null);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const result = await getGuideStats();
        if (active) setStats(result);
      } catch (err) {
        console.warn("Failed to load guide stats", err);
        if (active) setStats(null);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      <StatsCard
        label="Total Guides"
        value={stats ? stats.total : "—"}
        icon="/total_guides.svg"
        variant="brand"
      />
      <StatsCard
        label="Active Guides"
        value={stats ? stats.approved : "—"}
        icon="/active_guides.svg"
        variant="brand"
      />
      <StatsCard
        label="Total Connections"
        value={stats ? stats.connections.toLocaleString() : "—"}
        icon="/total_connections.svg"
        variant="brand"
      />
      <StatsCard
        label="Total Revenue"
        value={stats ? `$${stats.revenue.toLocaleString()}` : "—"}
        icon="/total_revenue.svg"
        variant="brand"
      />
    </div>
  );
}
